import React from 'react';
import { Link } from 'react-router-dom';
import { FiPhone, FiMail, FiMapPin, FiClock, FiChevronRight } from 'react-icons/fi';
import { FaFacebookF, FaInstagram, FaYoutube, FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Decorative Wave */}
      {/* <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path fill="var(--soft-charcoal)" d="M0,40 C360,100 720,0 1080,60 C1260,90 1380,50 1440,40 L1440,100 L0,100 Z" />
        </svg>
      </div> */}

      <div className="footer-main">
        <div className="container footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <span className="footer-logo-icon">✦</span>
            <h2>Prasannalakshmi</h2>
            <span className="footer-brand-sub">Kalyana Mandapam & Auditorium</span>
            <p className="footer-brand-desc">
              The perfect destination for your grand celebrations. Located in the heart of Kanjikode, Palakkad, Kerala,
              Prasannalakshmi Kalyana Mandapam & Auditorium offers world-class facilities for weddings, receptions, corporate events, and more.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
              <a href="https://wa.me/919447025460" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links-col">
            <h3>Explore</h3>
            <ul>
              <li><FiChevronRight /><Link to="/">Home</Link></li>
              <li><FiChevronRight /><Link to="/about">About Us</Link></li>
              <li><FiChevronRight /><Link to="/events-facilities">Events & Facilities</Link></li>
              <li><FiChevronRight /><Link to="/gallery">Gallery</Link></li>
              <li><FiChevronRight /><Link to="/booking">Booking & Enquiry</Link></li>
              <li><FiChevronRight /><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Events */}
          <div className="footer-links-col">
            <h3>Our Events</h3>
            <ul>
              <li><FiChevronRight /><Link to="/events-facilities">Wedding Ceremonies</Link></li>
              <li><FiChevronRight /><Link to="/events-facilities">Receptions</Link></li>
              <li><FiChevronRight /><Link to="/events-facilities">Engagements</Link></li>
              <li><FiChevronRight /><Link to="/events-facilities">Corporate Events</Link></li>
              <li><FiChevronRight /><Link to="/events-facilities">Birthday Parties</Link></li>
              <li><FiChevronRight /><Link to="/events-facilities">Cultural Programs</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact-col">
            <h3>Contact Us</h3>
            <div className="footer-contact-item">
              <FiMapPin />
              <div>
                <p>Prasannalakshmi Kalyana Mandapam & Auditorium </p>
                <p>Mercy College Road, Pallipuram Pg, Palakkad-678006, Kerala</p>
              </div>
            </div>
            <div className="footer-contact-item">
              <FiPhone />
              <div>
                <a href="tel:+919447025460">+91 94470 25460</a>
                {/* <a href="tel:+919876543211">+91 98765 43211</a> */}
              </div>
            </div>
            <div className="footer-contact-item">
              <FiMail />
              <div>
                <a href="mailto:info@prasannalakshmi.com">info@Prasannalakshmi.com</a>
                <a href="mailto:bookings@prasannalakshmi.com">bookings@Prasannalakshmi.com</a>
              </div>
            </div>
            <div className="footer-contact-item">
              <FiClock />
              <div>
                <p>Mon — Sun: 9:00 AM — 9:00 PM</p>
                <p>Available for events 24/7</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>&copy; {new Date().getFullYear()} Prasannalakshmi Kalyana Mandapam & Auditorium Kalyana Mandapam & Auditorium. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="/contact">Privacy Policy</a>
            <span>|</span>
            <a href="/contact">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
